'use client';

import { t } from '@lingui/macro';
import toast from 'react-hot-toast';
import { saveResponseAsFile } from '../utils/save-response-as-file';
import { composePdfUrl } from './compose-pdf-url';
import { ParamsSchema, type ParamsSchemaT } from './schema';

export const fetchUserPdfAction = async (params: ParamsSchemaT) => {
  const { type, locale, users } = ParamsSchema.parse(params);

  const isMultiple = users.length > 1;
  const toastId = `download-pdf-${type}-toast-${users.map((user) => user.id).join('-')}-${locale}`;

  try {
    toast.loading(t`Préparation du rapport...`, {
      id: toastId,
    });

    const result = await composePdfUrl(params);

    if (!result?.data) {
      throw new Error();
    }

    const {
      data: { pathname: url, body },
    } = result;

    const headers = new Headers();
    headers.set('Content-Type', 'application/json');

    const response = await toast.promise(
      fetch(
        url,
        !body
          ? {
              method: 'GET',
              headers,
            }
          : {
              method: 'POST',
              headers,
              body: JSON.stringify(body),
            }
      ),
      {
        loading: t`Génération du rapport en cours...`,
        success: t`Génération réussie`,
        error: t`Une erreur est survenue lors de la génération.`,
      },
      {
        id: toastId,
      }
    );

    if (!response.ok) {
      throw new Error();
    }

    await toast.promise(
      saveResponseAsFile(response, isMultiple ? 'rapport.zip' : 'rapport.pdf'),
      {
        loading: t`Préparation du téléchargement...`,
        success: t`Téléchargement réussi`,
        error: t`Une erreur est survenue lors du téléchargement.`,
      },
      {
        id: toastId,
      }
    );
  } catch (error) {
    toast.error(t`Une erreur est survenue...`, {
      id: toastId,
    });
    throw error;
  }
};
